import { useNavigate } from 'react-router-dom';

const useReRouteHook = () => {
	const navigate = useNavigate();

	const reRouteButtonRenderer = ({
		classes = '',
		nameText,
		url,
		endAdornment,
		startAdornment,
		spanClasses = '',
		onClick,
		applyTransparentBg = true,
		hideTextOnMobile = false,
		disabled = false,
	}: {
		url: string;
		classes?: string;
		nameText: string;
		endAdornment?: React.JSX.Element;
		startAdornment?: React.JSX.Element;
		spanClasses?: string;
		onClick?: () => void;
		applyTransparentBg?: boolean;
		hideTextOnMobile?: boolean;
		disabled?: boolean;
	}) => {
		return (
			<button
				disabled={disabled}
				onClick={() => {
					if (onClick) onClick();
					if (url === process.env.REACT_APP_MAIN_WEBSITE_URL) {
						window.location.href = url;
					} else if (url !== '#') {
						navigate(url);
						if (url === '/videos') {
							window.scrollTo({ top: 0, behavior: 'smooth' });
						}
						setTimeout(() => {
							const section = document.getElementById('kt_content_container');
							if (section) {
								const offset = window.innerWidth < 1200 ? 76 : 123;
								const sectionPosition =
									section.getBoundingClientRect().top + window.scrollY - offset;
								window.scrollTo({ top: sectionPosition, behavior: 'smooth' });
							}
						}, 100);
					} else {
						navigate(url);
					}
				}}
				className={`${applyTransparentBg ? 'bg-transparent' : ''} border-0 ${classes}`}>
				<div className="d-flex justify-content-between align-items-center w-100" >
					{startAdornment && (
						<div className={`${hideTextOnMobile ? 'pe-md-2' : 'pe-2'}`}>{startAdornment}</div>
					)}
					<span
						className={`text-start ${spanClasses} ${hideTextOnMobile ? 'd-none d-md-inline' : ''}`}>
						{nameText}
					</span>
					{endAdornment && <div> {endAdornment}</div>}
				</div>
			</button>
		);
	};

	return { reRouteButtonRenderer };
};

export default useReRouteHook;

